enum BillingTransactionStatus {
  'Any' = '',
  'Pending' = 'pending',
  'Posted' = 'posted',
}

export default BillingTransactionStatus;
